import { useEffect } from 'react';
import { debugLogger } from '@/utils/debug';

interface AuthModeEffectProps {
  tabParam: string | null;
  setAuthMode: (mode: "login" | "signup") => void;
}

/**
 * Component to handle auth mode updates based on URL parameter
 * Extracted to fix React Hook rules violation
 */
export const AuthModeEffect = ({ tabParam, setAuthMode }: AuthModeEffectProps) => {
  useEffect(() => {
    if (tabParam && (tabParam === "login" || tabParam === "signup")) {
      debugLogger.log("AuthPage: Updating auth mode from tab param:", tabParam);
      setAuthMode(tabParam as "login" | "signup");
    }
  }, [tabParam, setAuthMode]);

  return null; // This component only handles side effects
};
